
/**
 * Import the modules
 */
import MicroModal from 'micromodal';  // es6 module

/**
 * Create the methods
 */
const videos = {
    view() {
        /**
         * Find the element for the components
         */
        document.querySelectorAll('[data-component="video"]').forEach((component) => {
            let modal = document.querySelector('#video-view');

            /**
             * Open the modal that will contain the video
             */
            component.addEventListener('click', () => {
                let source = 'https://www.youtube-nocookie.com/embed/' + component.getAttribute('data-id') + '?enablejsapi=1';

                /**
                 * Set the path to the video content
                 */
                if (modal.querySelector('iframe#preview')) {
                    modal.querySelector('iframe#preview').setAttribute('src', source);
                }

                /**
                 * Show the video content
                 */
                MicroModal.show('video-view', {
                    onShow: (modal) => {
                        document.querySelector('body').classList.add('modal-screen-open');
                    },
                    onClose: (modal) => {
                        document.querySelector('body').classList.remove('modal-screen-open');

                        /**
                         * Verify that we have the iframe element
                         */
                        if (modal.querySelector('iframe#preview')) {
                            modal.querySelector('iframe#preview').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        }
                    }
                });
            });
        });
    }
}

export default videos;
